<template>
  <nav>
    <div class="nav-content">
      <div class="nav-links">
        <a
          class="m400 header__link nav-title"
          @click.prevent="navigateTo('/about')"
          >About</a
        >
        <!-- <a
          class="m400 header__link nav-title"
          @click.prevent="navigateTo('/grassroot-impact-initative')"
          >DIGU Cares</a
        > -->

        <!-- DIGU Cares Dropdown -->
        <v-menu
          v-model="diguCaresMenu"
          :open-delay="0"
          :close-delay="300"
          location="bottom center"
          transition="dropdown-transition"
        >
          <template v-slot:activator="{ props }">
            <p
              class="m400 nav-title"
              :class="{ 'active': diguCaresMenu }"
              v-bind="props"
              @click="toggleMenu('diguCaresMenu')"
            >
              DIGU Cares
              <v-icon class="dropdown-icon">mdi-chevron-down</v-icon>
            </p>
          </template>
          <v-list
            class="dropdown-menu"
            elevation="1"
            @mouseleave="closeMenu('diguCaresMenu')"
            @mouseenter="keepMenuOpen"
          >
            <v-list-item
              
            >
              <div class="dropdown-content"
                v-for="item in diguCaresItems"
                :key="item.title"
                @click="navigateTo(item.href)"
              >
                <div class="dropdown-title">{{ item.title }}</div>
                <div class="dropdown-description">{{ item.description }}</div>
              </div>
            </v-list-item>
          </v-list>
        </v-menu>

        <!-- For Businesses Dropdown -->
        <v-menu
          v-model="businessMenu"
          :open-delay="0"
          :close-delay="300"
          location="bottom center"
          transition="dropdown-transition"
        >
          <template v-slot:activator="{ props }">
            <p
              class="m400 nav-title"
              :class="{ active: businessMenu }"
              v-bind="props"
              @click="toggleMenu('businessMenu')"
            >
              For Businesses
              <v-icon class="dropdown-icon">mdi-chevron-down</v-icon>
            </p>
          </template>
          <v-list
            class="dropdown-menu"
            elevation="1"
            @mouseleave="closeMenu('businessMenu')"
            @mouseenter="keepMenuOpen"
          >
            <v-list-item>
              <div
                class="dropdown-content"
                v-for="item in businessItems"
                :key="item.title"
                @click="navigateTo(item.href)"
              >
                <div class="dropdown-title">{{ item.title }}</div>
                <div class="dropdown-description">{{ item.description }}</div>
              </div>
            </v-list-item>
          </v-list>
        </v-menu>

        <!-- Our Solutions Menu -->
        <v-menu
          v-model="solutionsMenu"
          :open-delay="0"
          :close-delay="300"
          location="bottom center"
          transition="dropdown-transition"
        >
          <template v-slot:activator="{ props }">
            <p
              class="m400 nav-title"
              :class="{ active: solutionsMenu }"
              v-bind="props"
              @click="toggleMenu('solutionsMenu')"
            >
              Our Solutions
              <v-icon class="dropdown-icon">mdi-chevron-down</v-icon>
            </p>
          </template>
          <v-list
            class="dropdown-menu"
            elevation="1"
            @mouseleave="closeMenu('solutionsMenu')"
            @mouseenter="keepMenuOpen"
          >
            <v-list-item>
              <div class="solutions-grid">
                <div
                  class="dropdown-content"
                  v-for="solution in solutions"
                  :key="solution.href"
                  @click="navigateTo(solution.href)"
                >
                  <div class="dropdown-title">{{ solution.title }}</div>
                  <div class="dropdown-description">
                    {{ solution.description }}
                  </div>
                </div>
              </div>
            </v-list-item>
          </v-list>
        </v-menu>

        <!-- For Job Seekers Dropdown -->
        <v-menu
          v-model="jobSeekersMenu"
          :open-delay="0"
          :close-delay="300"
          location="bottom center"
          transition="dropdown-transition"
        >
          <template v-slot:activator="{ props }">
            <p
              class="m400 nav-title"
              :class="{ active: jobSeekersMenu }"
              v-bind="props"
              @click="toggleMenu('jobSeekersMenu')"
            >
              For Job Seekers
              <v-icon class="dropdown-icon">mdi-chevron-down</v-icon>
            </p>
          </template>
          <v-list
            class="dropdown-menu"
            elevation="1"
            @mouseleave="closeMenu('jobSeekersMenu')"
            @mouseenter="keepMenuOpen"
          >
            <v-list-item>
              <div
                class="dropdown-content"
                v-for="item in jobSeekerItems"
                :key="item.title"
                @click="navigateTo(item.href)"
              >
                <div class="dropdown-title">{{ item.title }}</div>
                <div class="dropdown-description">{{ item.description }}</div>
              </div>
            </v-list-item>
          </v-list>
        </v-menu>
        <!-- <a
          class="m400 header__link nav-title"
          @click.prevent="navigateTo('/blogs-and-insights')"
          >Blogs</a
        > -->

        <!-- Resources Dropdown -->
        <v-menu
          v-model="resourcesMenu"
          :open-delay="0"
          :close-delay="300"
          location="bottom center"
          transition="dropdown-transition"
        >
          <template v-slot:activator="{ props }">
            <p
              class="m400 nav-title"
              :class="{ active: resourcesMenu }"
              v-bind="props"
              @click="toggleMenu('resourcesMenu')"
            >
              Resources
              <v-icon class="dropdown-icon">mdi-chevron-down</v-icon>
            </p>
          </template>
          <v-list
            class="dropdown-menu"
            elevation="1"
            @mouseleave="closeMenu('resourcesMenu')"
            @mouseenter="keepMenuOpen"
          >
            <v-list-item>
              <div
                class="dropdown-content"
                v-for="item in resourceItems"
                :key="item.title"
                @click="navigateTo(item.href)"
              >
                <div class="dropdown-title">{{ item.title }}</div>
                <div class="dropdown-description">{{ item.description }}</div>
              </div>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <!-- Contact Us Button -->
      <v-btn @click="redirectToCalendly" class="contact-btn">
        Schedule a Meeting
      </v-btn>
    </div>

    <!-- Overlay Background -->
    <transition name="backdrop">
      <div
        v-if="isAnyMenuOpen"
        class="backdrop-overlay"
        @click="closeAllMenus"
      ></div>
    </transition>
  </nav>
</template>

<script>
export default {
  name: 'DesktopMenu',
  data: () => ({
    diguCaresMenu: false,
    businessMenu: false,
    solutionsMenu: false,
    jobSeekersMenu: false,
    resourcesMenu: false,
    activeMenu: null,
    isHovered: false,

    diguCaresItems: [
      {
        title: 'Grassroot Impact Initiative',
        description:
          'Empowering Nepali talent through education, training, and careers',
        href: '/grassroot-impact-initative',
      },
      {
        title: 'Impact Stories',
        description:
          'Real stories of lives transformed through DIGU’s initiatives',
        href: '/impact-stories',

      },
      
    ],
    businessItems: [
      {
        title: 'Why DIGU for Businesses',
        description:
          'Build apps and scale teams with cost-effective, scalable solutions',
        href: '/why-digu-for-businesses',
      },
      {
        title: 'Customer Stories',
        description: 'See how DIGU has helped businesses succeed',
        href: '/customers',
      },
    ],
    solutions: [
      {
        title: 'Design My App',
        description: 'User-friendly UX/UI design for seamless experiences',
        href: '/design-my-app',
      },
      {
        title: 'Roadmap My App',
        description: 'Plan your app’s future with a strategic roadmap',
        href: '/roadmap-my-app',
      },
      {
        title: 'Build My App',
        description: 'Launch faster with a scalable, market-ready MVP',
        href: '/build-my-app',
      },
      {
        title: 'Staff Augmentation',
        description: 'Scale your team with top tech talent on demand',
        href: '/staff-augmentation',
      },
      {
        title: 'Review My App',
        description: 'Optimize performance, security, and scalability',
        href: '/review-my-app',
      },
      {
        title: 'Identity Management for My App',
        description: 'Secure, scalable identity solutions powered by Okta',
        href: '/implement-identity-management',
      },
    ],
    jobSeekerItems: [
      {
        title: 'Why DIGU for Career Opportunities',
        description: 'Unlock global opportunities while staying in Nepal',
        href: '/why-digu-for-career-opportunities',
      },
      {
        title: 'Learn about our Remote Career Acceleration Program',
        description: 'Advance your career through DIGU',
        href: '/remote-career',
      },
      {
        title: 'Verified Badges',
        description:
          'Earn credentials that highlight your expertise to employers',
        href: '/verified-badges',
      },
      {
        title: 'Join our Talent Pool',
        description:
          'Be part of DIGU’s Talent Pool and unlock job opportunities',
        href: '/talents-on-demand',
      },
    ],
    resourceItems: [
      {
        title: 'Blogs and Insights',
        description: 'Stay ahead with expert insights and industry trends',
        href: '/blogs-and-insights',
      },
      // {
      //   title: 'Research & Whitepapers',
      //   description: 'In-depth reports and case studies',
      //   href: '/research-and-whitepapers',
      // },
      {
        title: 'Experience Nepal',
        description: "Dive into Nepal's traditions, celebrations, and unique stories",
        href: '/experience-nepal',
      },
      {
        title: 'Learning Hub',
        description: "Explore webinars, workshops, and expert-led sessions",
        href: '/learning-hub',
      },
      {
        title: 'Upcoming Events',
        description: 'Stay updated on workshops, panels, and networking events',
        href: '/events',
      },
      {
        title: 'Trainings and Certifications',
        description: 'Gain new skills with expert-led training and certification',
        href: '/trainings-and-certifications',
      },
    ],
  }),
  computed: {
    isAnyMenuOpen() {
      return (
        this.diguCaresMenu ||
        this.businessMenu ||
        this.solutionsMenu ||
        this.jobSeekersMenu ||
        this.resourcesMenu
      );
    },
  },
  watch: {
    isAnyMenuOpen(newValue) {
      this.$emit('menu-state-change', newValue);
      if (newValue) {
        document.body.classList.add('menu-open');
      } else {
        document.body.classList.remove('menu-open');
      }
    },
  },
  methods: {
    toggleMenu(menu) {
      if (this[menu]) {
        this.closeAllMenus();
        this[menu] = true;
        this.activeMenu = menu;
        this.isHovered = true;
      } else {
        this.closeAllMenus();
      }
    },
    closeMenu(menu) {
      this.isHovered = false;
      if (this.activeMenu === menu) {
        this[menu] = false;
        this.activeMenu = null;
      }
    },
    keepMenuOpen() {
      this.isHovered = true;
    },
    redirectToCalendly() {
      window.open(process.env.VUE_APP_CALENDLY_LINK, '_blank');
    },
    closeAllMenus() {
      this.diguCaresMenu = false;
      this.businessMenu = false;
      this.solutionsMenu = false;
      this.jobSeekersMenu = false;
      this.resourcesMenu = false;
      this.activeMenu = null;
      this.isHovered = false;
    },
    navigateTo(path) {
      if (path) {
        this.$router
          .push(path)
          .then(() => {
            window.scrollTo({
              top: 0,
              behavior: 'smooth',
            });
          })
          .catch((err) => {
            if (err.name !== 'NavigationDuplicated') {
              console.error('Navigation error:', err);
            }
          });
        this.closeAllMenus();
      }
    },
    // handleDropdownClick(item) {
    //   if (item.title === 'Impact Stories') {
    //     this.goToImpactMeter();
    //   } else if (item.href) {
    //     this.navigateTo(item.href);
    //   }
    // },
    // goToImpactMeter() {
    //   this.$router.push('/').then(() => {
    //     setTimeout(() => {
    //       const impactMeterSection = document.getElementById('impactMeter');
    //       if (impactMeterSection) {
    //         const elementPosition =
    //           impactMeterSection.getBoundingClientRect().top +
    //           window.pageYOffset;
    //         const offsetPosition = elementPosition;
    //         window.scrollTo({
    //           top: offsetPosition,
    //           behavior: 'smooth',
    //         });
    //       }
    //     }, 100);
    //   });
    //   this.closeAllMenus();
    // },
  },
};
</script>

<style scoped>
nav {
  margin-top: 1rem;
  flex: 1;
  display: none;
  background-color: var(--light-1);
  z-index: 1001;
  height: 60px;
  position: sticky;
  top: 0;
  width: 100%;
}

.nav-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  height: 100%;
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 auto;
  margin-bottom: 1rem;
}

@media only screen and (min-width: 1282px) {
  nav {
    display: block;
  }
}

.nav-title {
  color: var(--dark-2);
  font-size: 18px;
  text-decoration: none;
  font-weight: 500;
  padding-inline: 0.5rem;
  cursor: pointer;
  transition: color 0.2s ease;
  white-space: nowrap;
}

.nav-title:hover,
.nav-title.active {
  color: #00aeff;
}

.dropdown-menu {
  border-radius: 0.75rem;
  margin-top: 2.5rem;
  min-width: 250px;
  /* padding: 0.5rem; */
  background-color: white;
  z-index: 1001;
  opacity: 1;
  transform: translateY(0);
  cursor: pointer;
}

.dropdown-transition-enter-active,
.dropdown-transition-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.dropdown-transition-enter-from,
.dropdown-transition-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.solutions-grid {
  display: grid;
  grid-template-columns: repeat(2, 2fr);
}

.dropdown-content {
  display: flex;
  flex-direction: column;
  /* border-radius: 0.5rem; */
  height: 55px;
  overflow: hidden;
  padding: 0.1rem;
  /* position: relative; */
  /* margin: 0.2rem 0; */
  padding: 0.3rem 1rem;
}
.dropdown-content:hover {
  background-color: var(--light-1);
}
.dropdown-title {
  color: var(--dark-2);
  font-size: 16px;
  /* transition: color 0.2s ease; */
  text-align: left;

  z-index: 1;
}

.dropdown-content:hover .dropdown-title {
  color: var(--primary-color);
}

.dropdown-description {
  font-size: 0.875rem;
  color: rgb(75, 73, 73);
  line-height: 1.4;
  opacity: 0;
  max-height: 0;
  overflow: hidden;
  /* transition: opacity 0.2s ease, max-height 0.2s ease; */
  text-align: left;
  z-index: 1;
}

.dropdown-content:hover .dropdown-description {
  opacity: 1;
  max-height: 60px;
}

.v-list-item {
  border: none !important;
  outline: none !important;
  padding: 0;
}

.v-list-item:hover {
  background: none !important;
}

.contact-btn {
  text-transform: none;
  font-weight: 500;
  background: #007ab2;
  width: 180px;
  height: 50px;
  color: white;
  border-radius: 10px;
  margin-bottom: 1rem;
}

.contact-btn:hover {
  background-color: #00aeff;
  color: white;
}

.backdrop-overlay {
  position: fixed;
  top: 110px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(143, 144, 146, 0.6);
  z-index: 1000;
  opacity: 1;
}

.backdrop-enter-active,
.backdrop-leave-active {
  transition: opacity 0.4s ease;
}

.backdrop-enter-from,
.backdrop-leave-to {
  opacity: 0;
}

.dropdown-icon {
  color: var(--primary-color-lighten);
}
</style>
